module.exports = __webpack_public_path__ + "static/2021_Case_Comp-6b1e51d3bc56093d8be6b683a68c5a3e.jpg";